export default {
  API_ENDPOINT: 'https://rocky-hamlet-31683.herokuapp.com/api',
};
